import { api } from "@/api/client";

/**
 * Phase 5 — Catalog API client.
 */
const catalog = {
  // Ingest (admin)
  ingestShopify: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/catalog/ingest/shopify", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
      timeout: 600000, // 10 min for big files
    });
  },
  ingestIc338: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/catalog/ingest/ic338", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
      timeout: 600000,
    });
  },
  // Phase 5.5 — GENQTY_AVAIL (disponibilidad real + imágenes + serials).
  ingestGenqtyAvail: (file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/catalog/ingest/genqty-avail", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
      timeout: 600000,
    });
  },
  // Phase 5.7 — Product photo upload.
  uploadPhoto: (sku, file, onProgress) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post(`/catalog/products/${encodeURIComponent(sku)}/photo`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
      timeout: 60000,
    });
  },
  markPhotoNotRequired: (sku) =>
    api.post(`/catalog/products/${encodeURIComponent(sku)}/photo-not-required`),
  unmarkPhotoNotRequired: (sku) =>
    api.delete(`/catalog/products/${encodeURIComponent(sku)}/photo-not-required`),
  rebuild: () => api.post("/catalog/rebuild", null, { timeout: 600000 }),

  // Reads
  products: (params) => api.get("/catalog/products", { params }),
  product: (sku) => api.get(`/catalog/products/${encodeURIComponent(sku)}`),
  productTransactions: (sku, limit = 200) =>
    api.get(`/catalog/products/${encodeURIComponent(sku)}/transactions`, {
      params: { limit },
    }),
  kpis: () => api.get("/catalog/kpis"),
  config: () => api.get("/catalog/config"),
  patchConfig: (body) => api.patch("/catalog/config", body),

  // Phase 5 — Liquidation list (Excel + PDF). Streams a binary blob.
  liquidationList: (body) =>
    api.post("/catalog/liquidation-list", body, {
      responseType: "blob",
      timeout: 600000, // up to 10 min — PDF with images can be slow
    }),
};

export default catalog;
